import { useState, useEffect } from 'react';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../config/firebase';

function Login({ notice }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);

  // App cierra la sesión si la cuenta no es super admin y avisa por aquí.
  useEffect(() => {
    if (notice) {
      setError(notice.text);
      setInfo('');
      setLoading(false);
    }
  }, [notice]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setInfo('');
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);
      // App verifica el acceso y cambia de pantalla; si lo rechaza llega `notice`.
    } catch (err) {
      console.error(err);
      switch (err.code) {
        case 'auth/user-not-found':
        case 'auth/wrong-password':
        case 'auth/invalid-credential':
          setError('Correo o contraseña incorrectos.');
          break;
        case 'auth/invalid-email':
          setError('El formato del correo es inválido.');
          break;
        case 'auth/too-many-requests':
          setError('Demasiados intentos. Espera unos minutos o restablece la contraseña.');
          break;
        case 'auth/network-request-failed':
          setError('Sin conexión. Revisa tu internet.');
          break;
        default:
          setError('Ocurrió un error al iniciar sesión.');
      }
      setLoading(false);
    }
  };

  const handleForgot = async () => {
    setError('');
    setInfo('');
    if (!email.trim()) {
      setError('Escribe tu correo y vuelve a pulsar «¿Olvidaste tu contraseña?».');
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setInfo(`Si ${email.trim()} tiene cuenta, recibirá un enlace para crear una contraseña nueva.`);
    } catch (err) {
      console.error(err);
      setError(err.code === 'auth/invalid-email' ? 'El formato del correo es inválido.' : 'No se pudo enviar el correo.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card animate-slide-up">
        <div className="login-brand">
          <img src="/Estoquia.jpg" alt="" className="login-logo" />
          <h1 className="login-title">
            <span>Esto</span><span className="text-secondary">quia</span>
          </h1>
        </div>
        <p className="login-subtitle">Panel de super administración</p>

        {error && <div className="notice notice-error" role="alert">{error}</div>}
        {info && <div className="notice notice-success" role="status">{info}</div>}

        <form onSubmit={handleSubmit} className="form-stack">
          <label className="field">
            <span className="field-label">Correo electrónico</span>
            <input
              type="email"
              required
              autoComplete="username"
              className="input-field"
              placeholder="admin@estoquia.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <label className="field">
            <span className="field-label">Contraseña</span>
            <input
              type="password"
              required
              autoComplete="current-password"
              className="input-field"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>

          <button type="submit" disabled={loading} className="btn btn-primary btn-lg w-full">
            {loading ? <><span className="spinner" /> Verificando…</> : 'Iniciar sesión'}
          </button>
        </form>

        <button type="button" className="link-btn" onClick={handleForgot}>
          ¿Olvidaste tu contraseña?
        </button>

        <div className="login-footer">
          <p>Acceso restringido al personal autorizado.</p>
          <a href="https://protonlab.site" target="_blank" rel="noopener noreferrer">By ProtonLab</a>
        </div>
      </div>
    </div>
  );
}

export default Login;
